import { createAction, props } from '@ngrx/store';

export const loadCustodianList = createAction('[Custodian] Load List');

export const loadCustodianListSuccess = createAction(
  '[Custodian] Load List Success',
  props<{ data: any[] }>()
);

export const loadCustodianListFailure = createAction(
  '[Custodian] Load List Failure',
  props<{ error: any }>()
);

export const clearCustodianList = createAction('[Custodian] Clear List');
